import { Box } from "@mui/material";
import { useContext, useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import authorityUserType from "../../assets/data/TkAuthorityProperty";
import { labelids } from "../../assets/data/TkExplanationProperty";
import TkButton from "../../components/atoms/TkButton";
import TkDownloadLink from "../../components/atoms/TkDownloadLink";
import TkInfoManual from "../../components/atoms/TkInfoManual";
import TkStepper from "../../components/atoms/TkStepper";
import TkTable from "../../components/atoms/TkTable";
import TkBackButton from "../../components/molecules/TkBackButton";
import TkContractorAndNumberLine from "../../components/molecules/TkContractorAndNumberLine";
import TkDateDialog from "../../components/molecules/TkDateDialog";
import TkMessageDialog from "../../components/molecules/TkMessageDialog";
import { BusinessContext } from "../../context/businessContext";
import { GlobalContext } from "../../context/globalContext";
import { IAPI_FAC036_Request } from "../../type/apiType/index";
import "./_style.scss";
import { httpIAPI_FAC002, httpIAPI_FAC036 } from "./api/request";
import { headList, stepData } from "./parts";
import { Status } from "../../assets/data/Constants";

/**
 * SCRC050024 廃止・休止・経営移管施設内容確認
 * @return SCRC050024
 */
const SCRC050024 = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const { state, setState } = useContext(GlobalContext);
  const { state: businessState } = useContext(BusinessContext);
  const [bodyList, setBodyList] = useState<any>([]);
  const userType = state.authInfo?.userType;
  const isUserTypeKiko = userType === authorityUserType.userTypeNumber.KIKO;
  const [open, setOpen] = useState(false);
  const [requestData, setReaquestData] = useState<IAPI_FAC036_Request>();
  const applyId = location.state?.applyId ?? businessState.job_18?.applyId;
  const [step, setStep] = useState(2);
  const [showButton, setShowButton] = useState(false);

  useEffect(() => {
    handleInit();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleInit = async () => {
    try {
      const res = await httpIAPI_FAC002({
        applyId: applyId,
      });
      if (res.resultCd === "I0000") {
        setState({
          ...state,
          errorMsgId: "",
        });
        let bodyList = res.facilityList?.map((item: any) => [
          {
            children: `${item.facilityNo}:${item.facilityName}`,
          },
          {
            children: item.reason,
          },
          {
            children: item.obsoleteDate,
          },
          {
            children: (
              <Box className="box">
                <Box className="row">
                  <Box>配置換え</Box>
                  <Box>{item.rearrangementStaffNum}人</Box>
                </Box>
                <Box className="row">
                  <Box>譲渡先法人へ異動</Box>
                  <Box>{item.continueTransferStaffNum}人</Box>
                </Box>
                <Box className="row">
                  <Box>退職</Box>
                  <Box>{item.retirementNo}人</Box>
                </Box>
                <Box className="row">
                  <Box>合計</Box>
                  <Box>{item.totalNum}人</Box>
                </Box>
              </Box>
            ),
          },
          {
            children: item.aCorpname && `${item.aCorpname}`,
          },
          {
            children: res.formList?.map((item2) => {
              if (item.facilityNo === item2.facilityNo) {
                return (
                  <TkDownloadLink
                    key={item2.serialNo}
                    dataname={item2.fileName!}
                    base64filedata={item2.fileBase64!}
                    downloadBase64={true}
                  ></TkDownloadLink>
                );
              } else {
                return "";
              }
            }),
          },
        ]);
        const facilityListData: any = [];
        res.facilityList?.forEach((facility: any) => {
          const data = {
            facilityNo: facility.facilityNo,
            rearrangementStaffNum: facility.rearrangementStaffNum,
            continueTransferStaffNum: facility.continueTransferStaffNum,
            retirementNo: facility.retirementNo,
            totalNum: facility.totalNum,
          };
          facilityListData.push(data);

          const excludedStatuses = [
            Status["届出待ち"],
            Status["差戻し一時保存"],
          ];
          if (!excludedStatuses.includes(res.latestApplyStatus as Status)) {
            setStep(3);
            setShowButton(false);
          } else {
            setStep(2);
            setShowButton(true);
          }
        });
        setReaquestData({
          applyId: applyId,
          facilityList: facilityListData,
          screenId: "SCRC050024",
        });
        setBodyList(bodyList);
      } else {
        setState({
          ...state,
          errorMsgId: res.resultCd,
        });
      }
    } catch (error) {
      navigate("/error");
    }
  };

  const handleOk = async (date?: any) => {
    try {
      // 共済契約対象施設等一部廃止届一括更新API呼び出し
      const res = await httpIAPI_FAC036({
        ...requestData,
        receptionDate: date,
      });
      if (res.resultCd === "I0000") {
        setState({
          ...state,
          errorMsgId: "",
        });
        navigate("/SCRC070008");
      } else {
        setState({
          ...state,
          errorMsgId: res.resultCd,
        });
        setOpen(false);
      }
    } catch (error) {
      navigate("/error");
    }
  };

  return (
    <Box className="SCRC050024" data-testid="SCRC050024PageForTest">
      <TkStepper steps={stepData} activeStep={step} />
      <TkInfoManual rule={"\\n"}>{labelids.labelid.LBLC050024_01}</TkInfoManual>
      {isUserTypeKiko && (
        <TkContractorAndNumberLine
          name="契約者（法人）名"
          no={`${businessState.common?.contractorNo ?? ""}:${
            businessState.common?.contractorName ?? ""
          }`}
        />
      )}

      <TkTable headList={headList} bodyList={bodyList} pagin />

      <Box className="buttonGroup">
        <TkBackButton />
        {showButton && (
          <TkButton onClick={() => setOpen(true)}>
            {isUserTypeKiko ? "申請" : "機構へ提出する"}
          </TkButton>
        )}
      </Box>

      {isUserTypeKiko ? (
        <TkDateDialog
          open={open}
          onOky={handleOk}
          onCancel={() => setOpen(false)}
          minDate={new Date("1900/01/01")}
          maxDate={new Date()}
          title="確認（申請）"
          contextText="申請を行いますが、問題ないでしょうか。"
          cancelText="いいえ"
          okText="はい"
        />
      ) : (
        <TkMessageDialog
          data-testid="TkMessageDialog"
          open={open}
          onOky={handleOk}
          onCancel={() => setOpen(false)}
          title="確認（機構へ提出する）"
          contextText="機構へ提出を行いますが、問題ないでしょうか。"
          cancelText="いいえ"
          okText="はい"
        />
      )}
    </Box>
  );
};

export default SCRC050024;
